'use client'

import { useState } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { Grid, IconButton, Tooltip, Avatar, Menu } from '@mui/material'
import { LaunchTwoTone as LaunchTwoToneIcon } from '@mui/icons-material'

// Types
import type { MouseEvent } from 'react'
import type { AvatarBarProps } from '@/types/components/molecules/avatar-bar'

// Configurations
import Config from '@/config'

// Helpers
import { useUserStore } from '@/helpers/store/user'

// Components
const SettingsModule = dynamic(() => import('@/components/molecules/settings'))

const AvatarBarMolecule = (props: AvatarBarProps) => {
	// Props
	const { lng, locale } = props

	// Varaibles
	const { name, picture } = useUserStore()
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

	return (
		<Grid size="auto">
			{Config.siteURL && (
				<Link href={Config.siteURL} target="_blank">
					<IconButton>
						<LaunchTwoToneIcon />
					</IconButton>
				</Link>
			)}

			<Tooltip title={locale.common.link.openSettings}>
				<IconButton
					aria-label="account of current user"
					aria-controls="avatar-menu"
					aria-haspopup="true"
					onClick={(event: MouseEvent<HTMLElement>) => {
						setAnchorEl(event.currentTarget)
					}}
					color="inherit"
					sx={{ ml: 1, p: 0.5 }}
				>
					<Avatar alt={name ?? undefined} src={picture ?? undefined} sx={{ width: 32, height: 32 }} />
				</IconButton>
			</Tooltip>

			<Menu
				keepMounted
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				slotProps={{
					paper: { variant: 'outlined' }
				}}
				onClose={() => {
					setAnchorEl(null)
				}}
				sx={{
					'& .MuiPaper-root': {
						width: 250,
						backdropFilter: 'blur(5px)'
					}
				}}
			>
				<SettingsModule lng={lng} locale={locale} />
			</Menu>
		</Grid>
	)
}

export default AvatarBarMolecule
